import { PwaInstallationContext } from './context';
import { useContext } from 'react';

export const usePwaInstallation = () => {
  const context = useContext(PwaInstallationContext);

  if (!context) {
    throw new Error('usePwaInstallation must be used within PwaInstallationProvider');
  }

  return context;
};